module.exports = __webpack_public_path__ + "img/livrare_email_sms.eb8118a5.svg";